import type { Levelbucket } from 'lumen/models';
import convertIndexToMarketInsightDemandLevel from 'lumen/utils/market-insight/index-to-color-level';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function convertIndexTextLevel(
  value: number,
  levelBucket: Levelbucket,
) {
  let textLevel = '';

  // Note (05/05/2020): was used in MI before the layout v2. Might be good remove if this stays this way

  // The bucket boundaries are different depending on what we need to show. This info is stored in the levelBucket argument
  if (levelBucket && levelBucket.levels && value) {
    // Reuse the convertIndexToMarketInsightDemandLevel util here. We just have a text representation of every bucket "level", so the checks are the same
    textLevel = `market_insight.rate_level.level${convertIndexToMarketInsightDemandLevel(
      value,
      levelBucket,
    )}`;
  }

  // This is a translation string
  return textLevel;
}
